export const VERSION_QUARTERS = [1, 2, 3, 4];
